module.exports = __webpack_public_path__ + "1b4a70853cde70c8c43dd6311d121a0b.jpg";